import React from "react";
import { default as WListSubheader } from "@mui/material/ListSubheader";

function ListItem(props) {
  return <WListSubheader {...props} />;
}

export default ListItem;
